import { mapParamsBySchema } from '../../../../util';
import { apiRequest } from '../../../../Services/Common/ApiRequest';
import Global from '../../../../Services/Common/Global';
import { WOR_DAI_Schema } from './WOR_DAI_Schema';
import useSearchMutaion from '../../../../Hooks/apis/useSearchMutaion';
import useDeleteMutation from '../../../../Hooks/apis/useDeleteMutaion';

const toDataResponse = (res) =>
  res != null && Array.isArray(res) ? { data: res } : res;

export const useSearch1 = (successOptions) => {
  return useSearchMutaion(async (context) => {
    const params = mapParamsBySchema(WOR_DAI_Schema.mapper.search1, context);
    console.log('[GetAccBasic02R1][WOR_DAI] request', {
      raw: {
        authCd: context.userInfo?.authCd ?? '',
        custCd: context.userInfo?.custCd ?? '',
        userId: context.userInfo?.userid ?? '',
        depCd: context.depCd ?? '',
        gongjongCd: context.gongjongCd ?? '',
        year: context.year ?? '',
        month: context.month ?? '',
      },
      params,
    });
    const res = await apiRequest(
      'post',
      Global.urls.WorkInfo.getAccBasic02R1,
      params
    );
    return toDataResponse(res);
  }, successOptions);
};

export const useDelete1 = (options = {}) => {
  return useDeleteMutation(async (item) => {
    const payload = mapParamsBySchema(WOR_DAI_Schema.mapper.delete1, item);
    return apiRequest('post1', Global.urls.WorkInfo.deleteAccBasic02D1, [
      payload,
    ]);
  }, options);
};
